import { render, staticRenderFns } from "./ny_diqu.vue?vue&type=template&id=9166355a&scoped=true&"
import script from "./ny_diqu.vue?vue&type=script&lang=js&"
export * from "./ny_diqu.vue?vue&type=script&lang=js&"
import style0 from "./ny_diqu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ny_diqu.vue?vue&type=style&index=1&id=9166355a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9166355a",
  null
  
)

export default component.exports